<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// list of checkboxes to render
const checks = [
  { key: 'umbodCheck1', label: 'ororku_umsokn_step11_umbodCheck1' },
  { key: 'umbodCheck2', label: 'ororku_umsokn_step11_umbodCheck2' },
  { key: 'umbodCheck3', label: 'ororku_umsokn_step11_umbodCheck3' },
  { key: 'umbodCheck4', label: 'ororku_umsokn_step11_umbodCheck4' },
  { key: 'umbodCheck5', label: 'ororku_umsokn_step11_umbodCheck5' },
  { key: 'umbodCheck6', label: 'ororku_umsokn_step11_umbodCheck6' },
  { key: 'umbodCheck7', label: 'ororku_umsokn_step11_umbodCheck7' },
  { key: 'umbodCheck8', label: 'ororku_umsokn_step11_umbodCheck8' },
  { key: 'umbodCheck9', label: 'ororku_umsokn_step11_umbodCheck9' },
  { key: 'umbodCheck10', label: 'ororku_umsokn_step11_umbodCheck10' },
  { key: 'umbodCheck11', label: 'ororku_umsokn_step11_umbodCheck11' }
]

// validation: each checkbox must be true
const rules = {
  umsokn: Object.fromEntries(checks.map(c => [c.key, { sameAs: sameAs(true) }]))
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <h2 class="form__header">{{ t('ororku_umsokn_step11_header') }}</h2>
    <p>{{ t('ororku_umsokn_step11_umbodSubHeader') }}</p>

    <v-row v-for="check in checks" :key="check.key">
      <v-col>
        <v-checkbox
          v-model="umsokn[check.key]"
          :readonly="props.disable"
          :label="t(`${check.label}`)"
          :error="v$.umsokn[check.key].$error"
          :error-messages="v$.umsokn[check.key].$error ? [t('ororku_umsokn_step11_umbodErrorText')] : []"
        />
      </v-col>
    </v-row>
  </div>
</template>
